import { render, staticRenderFns } from "./pharmaceuticalStatistics.vue?vue&type=template&id=ec261cd4&scoped=true"
import script from "./pharmaceuticalStatistics.vue?vue&type=script&lang=js"
export * from "./pharmaceuticalStatistics.vue?vue&type=script&lang=js"
import style0 from "./pharmaceuticalStatistics.vue?vue&type=style&index=0&id=ec261cd4&prod&scoped=true&lang=css"
import style1 from "./pharmaceuticalStatistics.vue?vue&type=style&index=1&id=ec261cd4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec261cd4",
  null
  
)

export default component.exports